import type { ReactNode } from "react";
import { cn } from "../lib/cn";

interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  label?: string;
}

const sizes: Record<NonNullable<SpinnerProps["size"]>, string> = {
  sm: "size-4 border-2",
  md: "size-6 border-2",
  lg: "size-8 border-4",
};

export function Spinner({ size = "md", className, label = "Loading" }: SpinnerProps): ReactNode {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        "border-ember inline-block animate-spin rounded-full border-t-transparent",
        sizes[size],
        className,
      )}
    />
  );
}
